// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"41375e3c","455":"29301e41"}[chunkId] + ".chunk.js";
};